import { render, staticRenderFns } from "./literacyEvaluationView.vue?vue&type=template&id=81d30b12&scoped=true"
import script from "./literacyEvaluationView.vue?vue&type=script&lang=js"
export * from "./literacyEvaluationView.vue?vue&type=script&lang=js"
import style0 from "./literacyEvaluationView.vue?vue&type=style&index=0&id=81d30b12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d30b12",
  null
  
)

export default component.exports